import * as ambassadorWixBillableItemsV1BillableItem from './billable-items-v1-billable-item-billable-items.http.js';
import * as ambassadorWixBillableItemsV1BillableItemTypes from './billable-items-v1-billable-item-billable-items.types.js';
import * as ambassadorWixBillableItemsV1BillableItemUniversalTypes from './billable-items-v1-billable-item-billable-items.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createBillableItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.CreateBillableItemRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.CreateBillableItemRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.CreateBillableItemResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.CreateBillableItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.createBillableItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/billable-items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getBillableItem(): __PublicMethodMetaInfo<
  'GET',
  { billableItemId: string },
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.GetBillableItemRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.GetBillableItemRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.GetBillableItemResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.GetBillableItemResponse
> {
  const payload = { billableItemId: ':billableItemId' } as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.getBillableItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/billable-items/{billableItemId}',
    pathParams: { billableItemId: 'billableItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateBillableItem(): __PublicMethodMetaInfo<
  'PATCH',
  { billableItemId: string },
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.UpdateBillableItemRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.UpdateBillableItemRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.UpdateBillableItemResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.UpdateBillableItemResponse
> {
  const payload = { billableItem: { id: ':billableItemId' } } as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.updateBillableItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/billable-items/{billableItem.id}',
    pathParams: { billableItemId: 'billableItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteBillableItem(): __PublicMethodMetaInfo<
  'DELETE',
  { billableItemId: string },
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.DeleteBillableItemRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.DeleteBillableItemRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.DeleteBillableItemResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.DeleteBillableItemResponse
> {
  const payload = { billableItemId: ':billableItemId' } as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.deleteBillableItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/billable-items/{billableItemId}',
    pathParams: { billableItemId: 'billableItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryBillableItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.QueryBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.QueryBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.QueryBillableItemsResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.QueryBillableItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.queryBillableItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/billable-items/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateBillableItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkCreateBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkCreateBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkCreateBillableItemsResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkCreateBillableItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.bulkCreateBillableItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/billable-items/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateBillableItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkUpdateBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkUpdateBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkUpdateBillableItemsResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkUpdateBillableItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.bulkUpdateBillableItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/billable-items/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteBillableItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkDeleteBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkDeleteBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkDeleteBillableItemsResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkDeleteBillableItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.bulkDeleteBillableItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/billable-items/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateBillableItemTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkUpdateBillableItemTagsRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkUpdateBillableItemTagsRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkUpdateBillableItemTagsResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkUpdateBillableItemTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.bulkUpdateBillableItemTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/billable-items/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateBillableItemTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkUpdateBillableItemTagsByFilterRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkUpdateBillableItemTagsByFilterRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.BulkUpdateBillableItemTagsByFilterResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.BulkUpdateBillableItemTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.bulkUpdateBillableItemTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/billable-items/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchBillableItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.SearchBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemTypes.SearchBillableItemsRequest,
  ambassadorWixBillableItemsV1BillableItemUniversalTypes.SearchBillableItemsResponse,
  ambassadorWixBillableItemsV1BillableItemTypes.SearchBillableItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillableItemsV1BillableItem.searchBillableItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/billable-items/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  BillableItem as BillableItemOriginal,
  Image as ImageOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateBillableItemRequest as CreateBillableItemRequestOriginal,
  CreateBillableItemResponse as CreateBillableItemResponseOriginal,
  GetBillableItemRequest as GetBillableItemRequestOriginal,
  GetBillableItemResponse as GetBillableItemResponseOriginal,
  UpdateBillableItemRequest as UpdateBillableItemRequestOriginal,
  UpdateBillableItemResponse as UpdateBillableItemResponseOriginal,
  DeleteBillableItemRequest as DeleteBillableItemRequestOriginal,
  DeleteBillableItemResponse as DeleteBillableItemResponseOriginal,
  QueryBillableItemsRequest as QueryBillableItemsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryBillableItemsResponse as QueryBillableItemsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  InternalQueryBillableItemsRequest as InternalQueryBillableItemsRequestOriginal,
  InternalCursorQuery as InternalCursorQueryOriginal,
  InternalCursorQueryPagingMethodOneOf as InternalCursorQueryPagingMethodOneOfOriginal,
  InternalCursorPaging as InternalCursorPagingOriginal,
  InternalQueryBillableItemsResponse as InternalQueryBillableItemsResponseOriginal,
  BulkCreateBillableItemsRequest as BulkCreateBillableItemsRequestOriginal,
  BulkCreateBillableItemsResponse as BulkCreateBillableItemsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkBillableItemResult as BulkBillableItemResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateBillableItemsRequest as BulkUpdateBillableItemsRequestOriginal,
  MaskedBillableItem as MaskedBillableItemOriginal,
  BulkUpdateBillableItemsResponse as BulkUpdateBillableItemsResponseOriginal,
  BulkUpdateBillableItemsResponseBulkBillableItemResult as BulkUpdateBillableItemsResponseBulkBillableItemResultOriginal,
  BulkDeleteBillableItemsRequest as BulkDeleteBillableItemsRequestOriginal,
  BulkDeleteBillableItemsResponse as BulkDeleteBillableItemsResponseOriginal,
  BulkDeleteBillableItemsResponseBulkBillableItemResult as BulkDeleteBillableItemsResponseBulkBillableItemResultOriginal,
  BulkUpdateBillableItemTagsRequest as BulkUpdateBillableItemTagsRequestOriginal,
  BulkUpdateBillableItemTagsResponse as BulkUpdateBillableItemTagsResponseOriginal,
  BulkUpdateBillableItemTagsResult as BulkUpdateBillableItemTagsResultOriginal,
  BulkUpdateBillableItemTagsByFilterRequest as BulkUpdateBillableItemTagsByFilterRequestOriginal,
  BulkUpdateBillableItemTagsByFilterResponse as BulkUpdateBillableItemTagsByFilterResponseOriginal,
  SearchBillableItemsRequest as SearchBillableItemsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchBillableItemsResponse as SearchBillableItemsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  CreateBillableItemApplicationErrors as CreateBillableItemApplicationErrorsOriginal,
  BulkUpdateBillableItemTagsApplicationErrors as BulkUpdateBillableItemTagsApplicationErrorsOriginal,
  BulkUpdateBillableItemTagsByFilterApplicationErrors as BulkUpdateBillableItemTagsByFilterApplicationErrorsOriginal,
} from './billable-items-v1-billable-item-billable-items.types.js';
